module.exports = __webpack_public_path__ + "static/media/sitesupt-ondemand.97258bd5.svg";